import { render, staticRenderFns } from "./healthyDetail.vue?vue&type=template&id=5c60722b&scoped=true"
import script from "./healthyDetail.vue?vue&type=script&lang=js"
export * from "./healthyDetail.vue?vue&type=script&lang=js"
import style0 from "./healthyDetail.vue?vue&type=style&index=0&id=5c60722b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60722b",
  null
  
)

export default component.exports